<template>  
  <v-card
    class="ma-4"
    color="white"
  >
    <v-card-title
      class="blue-grey white--text"
    >Pendaftaran Rekanan
    </v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        lazy-validation
      >
        <v-row>
          <v-col cols="12">
            <p class="text-left pt-4"> 
              Masukkan data berikut ini secara lengkap dan benar !
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-select label="Tipe Rekanan" v-model="jenis" :items="[ { text: 'Perusahaan', value: 'V'}, { text: 'Perseorangan', value: 'O'} ]" outlined></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              type="text"
              outlined
              label="E-mail"
              v-model="email"
              :rules="[rules.required, rules.email]"
              append-icon="check_circle"
            />
            <v-text-field
              type="text"
              outlined
              label="User ID"
              v-model="userId"
              :rules="[rules.required, rules.minUserId]"
              append-icon="check_circle"
              counter
            />
            <v-text-field
              :type="showPass ? 'text' : 'password'"
              outlined
              label="Password"
              v-model="password"
              :rules="[rules.required, rules.minPass]"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPass = !showPass"
              counter
            />
            <!-- <v-text-field
              type="password"
              outlined
              label="Password (Konfirmasi)"
              v-model="passwordKonfirmasi"
              :rules="[rules.required, rules.passwordConfirm(password)]"
              append-icon="check_circle"
            />           -->
          </v-col>
          <v-col cols="6">
            <v-text-field
              type="text"
              outlined
              label="Nama"
              v-model="nama"
              :rules="[rules.required]"
              append-icon="check_circle"
            />
            <v-text-field
              type="text"
              outlined
              label="Jabatan"
              v-model="jabatan"
              :rules="[]"
            />
            <v-text-field
              type="text"
              outlined
              label="No Telp. / HP"
              v-model="noHp"
              :rules="[]"
            />  
          </v-col>
        </v-row>      

        <!-- Formulir_Keikutsertaan_Vendor.doc
        SURAT_PERNYATAAN_NON_PKP.docx -->

        <p class="text-left">
          Kami akan mengirimkan link aktivasi login dan informasi lanjutan melalui email Anda. 
        </p>
        <p class="text-left">
          Selain itu, silakan download form di bawah ini untuk keperluan verifikasi. Setelah diisi dan discan, file ini diupload pada saat Pengisian Data Perusahaan
        </p>        
        <p class="text-left">
          1. <v-btn icon color="green" @click.prevent="getLinkDownload('daftar/Formulir_Keikutsertaan_Vendor.doc')" >
                            <v-icon>get_app</v-icon>
                          </v-btn> Download Formulir Keikutsertaan (Formulir_Keikutsertaan_Vendor.doc)
        </p>
        <p class="text-left">
          2. <v-btn icon color="green" @click.prevent="getLinkDownload('daftar/SURAT_PERNYATAAN_NON_PKP.docx')" >
                            <v-icon>get_app</v-icon>
                          </v-btn> Download Surat Pernyataan Non PKP (SURAT_PERNYATAAN_NON_PKP.docx)
        </p>
      </v-form>
    </v-card-text>
    <v-divider class="mt-2" />
    <v-card-actions class="">
      <v-btn color="success" dark @click="mendaftarClick" v-if="!daftarDone">Daftar</v-btn>     
      <v-btn color="blue" dark click="" to="/">{{ Batal }}</v-btn>
    </v-card-actions>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

  </v-card>  
</template>

<script>
import axios from 'axios'
import { rules as Rules } from './../../lib/rules'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      // data registrasi PIC
      jenis: 'V',
      email: '',
      userId: '',
      password: '',
      // passwordKonfirmasi: '',      
      nama: '',
      jabatan: '',
      noHp: '',      
      rules: {
        required: Rules.required,
        email: Rules.email,
        minPass: value => value.length >= this.$store.getters.PANJANG_MIN_PASSWD || `Password minimal ${this.$store.getters.PANJANG_MIN_PASSWD} karakter`,
        minUserId: value => value.length >= this.$store.getters.PANJANG_MIN_LOGIN || `User ID minimal ${this.$store.getters.PANJANG_MIN_LOGIN} karakter`
      },
      showPass: false,
      // valid: true,
      daftarDone: false,      
      batal: 'Batal',
      
      submitting: false,
    }
  },
  computed: {
    Batal: function() {
      return this.daftarDone ? 'Kembali ke Home' : 'Batal'
    }
  },
  methods: {
    mendaftarClick: async function() {
      if (this.$refs.form.validate()) {
        const msg = {
          jenis: this.jenis,
          email: this.email,
          userId: this.userId,
          password: this.password,
          nama: this.nama,
          jabatan: this.jabatan,
          noHp: this.noHp
        }
        this.$store.dispatch('displayProgBar')
        this.submitting = true;

        axios.post(apiUrl+'/registrasi', msg)
        .then((response) => {
          console.log(response)
          this.daftarDone = true
          this.batal = 'Kembali ke Home'
          this.$store.dispatch('displayAlert', 
            {color: 'success', message: `Permintaan untuk registrasi Rekanan sukses dilakukan. Silahkan lanjutkan proses aktivasi melalui email Anda !`})
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('displayAlert', {color: 'error', message: error.response.data.message})
        })
        .finally(() => {
          console.log('finally')
          this.$store.dispatch('closeProgBar')
          this.submitting = false;
        })
      }
    },
    getLinkDownload: function(dok) {
      axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
  }
}
</script>

<style>

</style>